<template>
  <div class="historicalSensorManagement-page">
    <div class="all-content-container">
      <div class="table-content-container">
        <div class="table-title-container">
          <div class="table-title-title">
            <h4>传感器</h4>
          </div>
          <div class="table-content-title">
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="属性名称：">
                <el-select v-model="input" placeholder="所属分组">
                  <el-option label="全部" value="quanbu"></el-option>
                  <el-option label="温度" value="dapeng01"></el-option>
                  <el-option label="湿度" value="dapeng02"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="日期选择：">
                <el-select v-model="input1" placeholder="所属分组">
                  <el-option label="近5分钟" value="quanbu"></el-option>
                  <el-option label="近10分钟" value="dapeng01"></el-option>
                  <el-option label="近20分钟" value="dapeng02"></el-option>
                  <el-option label="近30分钟" value="dapeng03"></el-option>
                  <el-option label="昨天" value="dapeng04"></el-option>
                  <el-option label="近7天" value="dapeng04"></el-option>
                  <el-option label="自定义" value="dapeng04"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="mar-l">
                <el-button type="primary" @click="onSubmit">查询</el-button>
                <el-button @click="onSubmit">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table-content">
          <div class="table-table">
            <el-table :data="tableData" style="width: 100%" border>
              <el-table-column prop="sbmc" label="设备名称" align="center"></el-table-column>
              <el-table-column prop="sbbm" label="属性名称" align="center"></el-table-column>
              <el-table-column prop="ssfz" label="数值" align="center"></el-table-column>
              <el-table-column prop="sswg" label="平台数据接收时间" align="center"></el-table-column>
              <el-table-column prop="cjjg" label="查询指令下发时间" align="center"></el-table-column>
              <el-table-column prop="gzzt" label="平均响应时间" align="center"></el-table-column>
              <!-- <el-table-column label="操作" align="center">
                <el-link type="primary" :underline="false" class="marginLr">编辑</el-link>
                <el-link type="primary" :underline="false" class="marginLr">删除</el-link>
                <el-link type="primary" :underline="false" class="marginLr">停用</el-link>
                <el-link type="primary" :underline="false" class="marginLr">历史记录</el-link>
              </el-table-column>-->
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      input: "",
      input1: "",
      input2: "",
      tableData: [
        {
          sbmc: "温度传感器",
          sbbm: "温度",
          ssfz: "22",
          sswg: "2019-12-06 00:00:10.141",
          cjjg: "2019-12-06 00:00:10.089",
          gzzt: "52ms"
        },
        {
          sbmc: "温度传感器",
          sbbm: "温度",
          ssfz: "22",
          sswg: "2019-12-06 00:00:10.141",
          cjjg: "2019-12-06 00:00:10.089",
          gzzt: "52ms"
        },
        {
          sbmc: "温度传感器",
          sbbm: "温度",
          ssfz: "22",
          sswg: "2019-12-06 00:00:10.141",
          cjjg: "2019-12-06 00:00:10.089",
          gzzt: "52ms"
        }
      ]
    };
  },
  methods: {
    onSubmit() {}
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/historicalSensorManagement.scss";
</style>